export default __webpack_public_path__ + "static/media/video-testimonial.2e284a6f.jpg";